export default "__VITE_PUBLIC_ASSET__71cdc864__"